module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-card-surf-393111e22e0fd6a37bb860b00f38e84a.webp";